export const formatNumber = (x, options) => {
    const formatter = new Intl.NumberFormat(undefined, options);
    return formatter.format(x);
};
